import { setErrorMap, ZodIssueCode } from 'zod';

setErrorMap((issue, ctx) => {
  if (
    (issue.code === ZodIssueCode.invalid_type && issue.received === 'undefined')
    || (issue.code === ZodIssueCode.custom && issue.message === 'Required')
  ) {
    return { message: 'Pole je povinné', force: true };
  }

  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === 'null') {
        return { message: 'Pole je povinné', force: true };
      }
      return {
        message: `Očekáván typ ${issue.expected}, ale je ${issue.received}`,
        force: true,
      };

    case ZodIssueCode.too_small:
      if (issue.type === 'string') {
        return {
          message: `Minimální délka je ${issue.minimum} ${
            issue.minimum === 1 ? 'znak' : 'znaků'
          }`,
          force: true,
        };
      }
      if (issue.type === 'array') {
        return {
          message: `Musí obsahovat alespoň ${issue.minimum} položek`,
          force: true,
        };
      }
      return {
        message: `Musí být větší než ${issue.minimum}`,
        force: true,
      };

    case ZodIssueCode.too_big:
      if (issue.type === 'string') {
        return {
          message: `Maximální délka je ${issue.maximum} znaků`,
          force: true,
        };
      }
      if (issue.type === 'array') {
        return {
          message: `Maximálně ${issue.maximum} položek`,
          force: true,
        };
      }
      return {
        message: `Musí být menší než ${issue.maximum}`,
        force: true,
      };

    case ZodIssueCode.invalid_string:
      if (issue.validation === 'email') {
        return { message: 'Musíte zadat platnou e-mailovou adresu', force: true };
      }
      if (issue.validation === 'url') {
        return { message: 'Musíte zadat platnou URL adresu', force: true };
      }
      return { message: 'Neplatný formát', force: true };

    case ZodIssueCode.invalid_date:
      return { message: 'Musíte zadat platné datum', force: true };

    case ZodIssueCode.custom:

      return { message: issue.message || 'Neplatná hodnota', force: true };

    default:
      return { message: ctx.defaultError, force: true };
  }
});
